<template>
    <div>
        <modal :name="modal_name" transition="nice-modal-fade" class="final-modal">
            <div class="v-modal-content">
                <div class="v-modal-header align-items-center">
                    <span class="v-modal-dialog-title v-modal-title">ADD NEW WIFI NETWORK</span>
                    <span class="pull-right" style="cursor:pointer;" @click="cancel()">
                        <i class="icon icon-close" style="font-size: 22px!important; color: #5d5b5b;"></i>
                    </span>
                </div>
                <div class="v-modal-body pr-0">
                    <div class="v-modal-layout pr-3">
                        <div class="row first-middle-input">                    
                            <div class="col-md-6">
                                <div class="form-group mt-0 contactGroup">
                                    <input
                                        class="inputContact"
                                        v-validate="'required'"
                                        type="text"
                                        name="wifiName"
                                        autofocus
                                        required
                                        v-model.trim="wifi.name"
                                        :maxlength="wifiName"
                                        autocomplete="off"
                                    />
                                    <span class="highlightContact"></span>
                                    <span class="barContact"></span>
                                    <label class="labelContact">
                                    Enter Wifi Network Name
                                        <sup>★</sup>
                                    </label>
                                    <span
                                        class="invalid-feedback-form"
                                        v-show="errors.has('wifiName')"
                                        style="display:inline;"
                                    >{{ errors.first('wifiName') }}</span>
                                    <p
                                        class="pull-right text-right text-grey font-600 fs-12 pt-1"
                                    >{{wifiName - wifi.name.length}} / {{wifiName}}</p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mt-0 contactGroup">
                                    <input
                                        class="inputContact"
                                        v-validate="'required'"
                                        type="text"
                                        name="wifiPassword"
                                        autofocus
                                        required
                                        v-model.trim="wifi.password"
                                        :maxlength="wifiPassword"
                                        autocomplete="off"
                                    />
                                    <span class="highlightContact"></span>
                                    <span class="barContact"></span>
                                    <label class="labelContact">
                                    Enter Wifi Password
                                        <sup>★</sup>
                                    </label>
                                    <span
                                        class="invalid-feedback-form"
                                        v-show="errors.has('wifiPassword')"
                                        style="display:inline;"
                                    >{{ errors.first('wifiPassword') }}</span>
                                    <p
                                        class="pull-right text-right text-grey font-600 fs-12 pt-1"
                                    >{{wifiPassword - wifi.password.length}} / {{wifiPassword}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-footer text-center pt-5">
                        <button class="btn btn-link btn-smm" :disabled="create_wifi_network_api_inprogress" @click="cancel">CANCEL</button>
                        <button
                            class="btn btn-secondary btn-smm text-uppercase ml-5" :disabled="create_wifi_network_api_inprogress" 
                            @click="save"
                        >SAVE
                        <half-circle-spinner :animation-duration="1000" :size="20" v-if="create_wifi_network_api_inprogress" color="#00448b" style="position: absolute;top:6px;right:2px" />
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import NetworkSettings from './mixins/networksettings'
import { HalfCircleSpinner } from "epic-spinners";
export default {
    data(){
        return{
            wifiName:30,
            wifiPassword:30,            
            wifi:{
                name:'',
                password:'',
                type:'wifi_settings'

            },
            create_wifi_network_api_inprogress: false
        }
    },
    props:['modal_name'],
    mixins: [NetworkSettings],
    components: {
        HalfCircleSpinner
    },
    methods:{
        cancel(){
            this.$modal.hide(this.modal_name)
            this.wifi = {
                name:'',
                password:'',
                type:'wifi_settings'
            }
        },
        async save() {
            try {
                this.create_wifi_network_api_inprogress = true;
                const result = await this.$validator.validateAll()
                if (result) {                
                    let response = await this.createSetting(this.wifi)
                    this.$emit('savewifi')
                    this.$swal({
                        title: 'Wifi Network Added Successfully',
                        text: '',
                        type: 'success'
                    })                
                    this.cancel()
                    this.create_wifi_network_api_inprogress = false;
                } else {
                    this.create_wifi_network_api_inprogress = false;
                }
            } catch (reason) {               
                // TODO: Handle Error
                this.$swal('Warning', reason, 'warning')
                this.create_wifi_network_api_inprogress = false;
            }
        }
    },
    created() {
        const dict = {
            custom: {
                wifiName: {
                    required: () => 'Wifi Name is Required'
                },
                wifiPassword: {
                    required: () => 'Wifi Password is Required'
                }
            }
        }
        this.$validator.localize('en', dict)
    },
}
</script>